import StorageObject from 'ember-local-storage/local/object';

const Storage = StorageObject.extend();

Storage.reopenClass({
  initialState() {
    return {
      // Per-classgroup configurations keyed by classGroupUuid
      classGroupConfigs: {},
      // Current event ID (to detect event changes)
      currentEventId: null
    };
  }
});

export default Storage;
